module.exports = __webpack_public_path__ + "img/ico_ex_yello.8cf657ba.svg";